import {Component} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Select, Store} from '@ngxs/store';
import {PharmacyState} from '../../../shared/states/pharmacy/pharmacy.state';
import {Observable} from 'rxjs/internal/Observable';
import {IPharmacy} from '../../../shared/interfaces/pharmacy.interface';
import {SetCurrentPharmacy} from '../../../shared/states/pharmacy/pharmacy.actions';
import {SetPharmacyId} from '../../../shared/states/auth/auth.actions';
import {Router} from '@angular/router';

@Component({
  selector: 'app-choose-pharmacy',
  templateUrl: './choose-pharmacy.component.html',
  styleUrls: ['./../login/login.component.scss', './../../auth.scss'],
})
export class ChoosePharmacyComponent {
  selectPharmacyForm: UntypedFormGroup;

  @Select(PharmacyState.pharmacies) pharmacies$: Observable<IPharmacy[]>;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private router: Router,
  ) {
    this.selectPharmacyForm = this.fb.group({
      pharmacyId: [null, [Validators.required]],
    });
  }

  continue(): void {
    this.store.dispatch(new SetPharmacyId(this.selectPharmacyForm.get('pharmacyId')?.value));
    this.store.dispatch(new SetCurrentPharmacy(this.selectPharmacyForm.get('pharmacyId')?.value));
    this.router.navigateByUrl('dashboard');
  }

}
